import type { Aggregation } from '@talos/kyoko';
import type { MarketSelectorPreset } from '../types';

/**
 * Label for a selected market-selector aggregation preset.
 * Matches preset mapping ({@link mapUserAggregationsToMarketSelectorPresets}: DisplayName ?? Name)
 * and other aggregation lookups (e.g. price grid: preset label ?? id).
 */
export function getMarketSelectorAggregationLabel(
  aggregationName: string | undefined,
  aggregationPresetsByID: Map<string, MarketSelectorPreset> | undefined,
  aggregationsByName: Map<string, Aggregation>
): string | undefined {
  if (aggregationName == null) {
    return undefined;
  }

  const presetLabel = aggregationPresetsByID?.get(aggregationName)?.label;
  if (presetLabel != null) {
    return presetLabel;
  }

  const aggregation = aggregationsByName.get(aggregationName);
  if (aggregation != null) {
    return aggregation.DisplayName ?? aggregation.Name;
  }

  return aggregationName;
}
